// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--opsyk","container-phone":"_2787e5dfdf--container-phone--ecOZw"};